<template>
  <div>
    <FormSect title="Parametrai">
      <Row>
        <Column :md="6">
          <Field
            label="Gamintojas"
            :value.sync="solarModule.manufacturer" />
        </Column>
        <Column :md="6">
          <Field
            label="Modelis"
            :maxlength="50"
            :minlength="1"
            :value.sync="solarModule.model" />
        </Column>
        <Column :md="6">
          <Field
            label="Galia (W)"
            :max="10000"
            :min="1"
            type="number"
            :value.sync="solarModule.capacity" />
        </Column>
        <Column :md="6">
          <Field
            label="Garantija (metai)"
            :max="100"
            :min="1"
            type="number"
            :value.sync="solarModule.warranty" />
        </Column>
        <Column>
          <Field
            label="Nuoroda į aprašymą"
            :maxlength="1000"
            required
            :value.sync="solarModule.moreInfoSrc" />
        </Column>
      </Row>
    </FormSect>
    <FormSect title="Aprašymas">
      <VMdEditor v-model="description" />
    </FormSect>
  </div>
</template>

<script>

import '@kangc/v-md-editor/lib/style/base-editor.css'
import '@kangc/v-md-editor/lib/theme/style/github.css'
import VMdEditor from '@kangc/v-md-editor'
import enUS from '@kangc/v-md-editor/lib/lang/en-US'
import { getters } from 'views/utils'
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import hljs from 'highlight.js'

VMdEditor.xss.extend({
  // extend white list
  whiteList: {
    source: [],
  },
})

VMdEditor.use(githubTheme, {
  Hljs: hljs,
})
VMdEditor.lang.use('en-US', enUS)

export default {
  components: {
    VMdEditor,
  },
  props: {
    solarModule: Object,
  },
  data() {
    return {
      description: this.solarModule.description || '',
    }
  },
  computed: {
    ...getters(),
  },
  watch: {
    description: {
      immediate: true,
      handler(description) {
        this.solarModule.description = description
      },
    },
  },
}
</script>

<style lang="scss">
</style>
